import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { useUserStore } from "./store/user.store";
import { router } from "./router/main.router";
import Spinner from "./components/spinner.components";
import { useDashboardConfigCommonHttp } from "./hooks/http/common/users/dashboard-config.common.http";
import { Toaster } from "./components/ui/toaster";
import { useToast } from "./hooks/use-toast";
import { TooltipProvider } from "./components/ui/tooltip";
import { handleHttpError } from "./utils/utils";

function App() {
  const [initializing, setInitializing] = useState(true);
  const { token, setUser, logout, setBrands } = useUserStore();
  const { execute: fetchConfig } = useDashboardConfigCommonHttp();
  const { toast } = useToast();

  async function getConfig() {
    const response = await fetchConfig({ body: null });
    if (!response.success) {
      if (response.error.logout) {
        await logout();
      }
      return handleHttpError(response, toast);
    }
    setBrands(response.data.brands);
    setUser(response.data.user);
  }

  async function init() {
    setInitializing(true);
    if (token) {
      await getConfig();
    }
    setInitializing(false);
  }

  const isBrandDash = window.location.pathname.startsWith("/brands");

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const style = document.createElement("style");
    if (isBrandDash) {
      style.innerHTML = `
    input:-webkit-autofill ,
    input:-webkit-autofill:hover , 
    input:-webkit-autofill:focus , 
    input:-webkit-autofill:active{
    -webkit-background-clip: text ;
    -webkit-text-fill-color: #000000 ;
    transition: #000000 5000s ease-in-out 0s;
    }
    `;
      document.head.appendChild(style);
      init();
      return;
    }
    style.innerHTML = `
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active{
    -webkit-background-clip: text;
    -webkit-text-fill-color: #ffffff;
    transition: #ffffff 5000s ease-in-out 0s;}`;
    document.head.appendChild(style);

    init();
  }, []);

  if (initializing) {
    return (
      <div className="flex justify-center items-center w-full h-screen text-primary">
        <Spinner />
      </div>
    );
  }

  return (
    <>
      <TooltipProvider>
        <div className="flex flex-col flex-1 h-svh">
          <div className="z-0 flex flex-col flex-1 h-full">
            <RouterProvider router={router} />
          </div>
        </div>
      </TooltipProvider>
      <Toaster />
    </>
  );
}

export default App;
